// The shell reads today's system-wide idle and screen-lock signals. A Mac
// asleep or offline stops reporting; the server considers it away after 60s.
import { useEffect, useMemo } from 'react'
import { inMacShell } from '../lib/shell'
import { useBoardState, useStore } from '../store/context'

export function MacPresence() {
  const store = useStore()
  const { me, status } = useBoardState()
  const identity = `${me?.workspace.id}/${me?.member?.id}`
  const api = useMemo(() => store.notifications(), [store, identity])
  useEffect(() => {
    if (!inMacShell() || status !== 'ready' || !me?.member) return
    const report = () => {
      const state = document.documentElement.dataset.macPresence
      if (state === 'here' || state === 'away') void api.presence(state === 'here').catch(() => {})
    }
    report()
    window.addEventListener('poulpe-presence', report)
    return () => window.removeEventListener('poulpe-presence', report)
  }, [api, status, me?.member])
  return null
}
